import { ReactNode } from 'react';
import { PopoverPosition } from 'react-tiny-popover';

export type ValueOf<T> = T[keyof T];

export const TOOLTIP_DELAY_MS = 500;

export const TooltipDirection = {
  RIGHT: 'tooltip-right',
  LEFT: 'tooltip-left',
  TOP: 'tooltip-top',
  TOP_LEFT: 'tooltip-top-left',
  BOTTOM: 'tooltip-bottom',
  BOTTOM_LEFT: 'tooltip-bottom-left',
  BOTTOM_RIGHT: 'tooltip-bottom-right',
} as const;

export const TooltipSize = {
  AUTO: 'w-auto',
  FIT: 'w-fit',
  MAX: 'w-max',
  FULL: 'w-full',
} as const;

export const TooltipTheme = {
  LIGHT: 'light',
  DARK: 'dark',
} as const;

export interface TooltipProps {
  tooltip?: ReactNode;
  direction?: ValueOf<typeof TooltipDirection>;
  size?: ValueOf<typeof TooltipSize>;
  theme?: ValueOf<typeof TooltipTheme>;
  contentSize?: ValueOf<typeof TooltipSize>;
  delay?: boolean;
  isOpen?: boolean;
  isHiddenOnFocus?: boolean;
  wrapperClassName?: string;
}

export const directionToPositions: Record<string, PopoverPosition[]> = {
  [TooltipDirection.RIGHT]: ['right'],
  [TooltipDirection.LEFT]: ['left'],
  [TooltipDirection.TOP]: ['top'],
  [TooltipDirection.TOP_LEFT]: ['top'],
  [TooltipDirection.BOTTOM]: ['bottom'],
  [TooltipDirection.BOTTOM_LEFT]: ['bottom'],
  [TooltipDirection.BOTTOM_RIGHT]: ['bottom'],
};
